export enum TournamentPreviewImage {
    easter_egg_hunt = 'img/tournaments/preview_easter_egg_hunt.jpg',
    egg_hunt_map = 'img/tournaments/preview_egg_hunt_map.png',
    golden_bunny = 'img/tournaments/preview_golden_bunny.png',
    golden_bunny2 = 'img/tournaments/preview_golden_bunny2.png',
    march_madness = 'img/tournaments/preview_march_madness.png',
    pot_gold = 'img/tournaments/preview_pot_gold.png',
    spring_frenzy = 'img/tournaments/preview_spring_frenzy.png',
    clover_clash = 'img/tournaments/preview_clover_clash.png',
    Poker_14Feb_Tournament = 'img/tournaments/preview_poker_14feb_tournament.png',
    XMass_Rush_Tournaments = 'img/tournaments/preview_xmas_rush.jpg',
    No_Joke_Tournament = 'img/tournaments/preview_no_joke_tournament.jpg',
    Royal_Slots_Tournament = 'img/tournaments/preview_royal_slots_tournament.jpg',
    NY_Jackpot_Tournament = "img/tournaments/preview_ny_jackpot_tournament.jpg",
    Super_Bowl_Tournament = "img/tournaments/preview_super_bowl_tournament.jpg",
    Xmas_Poker_v1 = "img/tournaments/preview_poker_ny_v1_tournament.jpg",
    Xmas_Poker_v2 = "img/tournaments/preview_poker_ny_v2_tournament.jpg",
    Poker = "img/tournaments/preview_poker_tournament.jpg",
    WC_Bronze = "img/tournaments/preview_wc_bronze.jpg",
    WC_Silver = "img/tournaments/preview_wc_silver.jpg",
    WC_Gold = "img/tournaments/preview_wc_gold.jpg",
    Jackpot_Tournament = "img/tournaments/preview_jackpot_tournament.jpg",
    VIP_Tournament = "img/tournaments/preview_vip_tournament.jpg",
    Flash_Tournament = "img/tournaments/preview_flash_tournament.jpg",
    Diamond_Tournament = "img/tournaments/preview_diamond_tournament.jpg",
    Gold_Tournament = "img/tournaments/preview_gold_tournament.jpg",
    Silver_Tournament = "img/tournaments/preview_silver_tournament.jpg",
    Bronze_Tournament = "img/tournaments/preview_bronze_tournament.jpg",
    BlackFriday = "img/tournaments/preview_blackfriday.png",
    Environment = "img/tournaments/preview_env.png",
    Parents = "img/tournaments/preview_parents.jpg",
    ThanksGiving = "img/tournaments/preview_thanksgiving_day.png",
    July4 = "img/tournaments/preview_4july.jpg",
    Fathers_Day = "img/tournaments/preview_fathers_day.png",
    Flag_Day = "img/tournaments/preview_flag_day.png",
    Halfway_NY = "img/tournaments/preview_halfway_new_year.png",
    Summer = "img/tournaments/preview_summer.png",
    Yoga = "img/tournaments/preview_yoga.png",
    July4_2025 = "img/tournaments/preview_4july_2025.png",
    CheerUp = "img/tournaments/preview_cheer_up.png",
    Chocolate = "img/tournaments/preview_chocolate.png",
    Cousins = "img/tournaments/preview_cousins.png",
    Emoji = "img/tournaments/preview_emoji.png",
    Friendship = "img/tournaments/preview_friendship.png",
    Moon = "img/tournaments/preview_moon.png",
    Bonanza = "img/tournaments/preview_bonanza.png",
    Dog = "img/tournaments/preview_dog.png",
    Dollar = "img/tournaments/preview_dollar.png",
    End_Summer = "img/tournaments/preview_end_summer.png",
    Left_Hand = "img/tournaments/preview_lefthand.png",
    Photo = "img/tournaments/preview_photo.png",
    Slot = "img/tournaments/preview_slot.png",
    Labor_Day_2025 = "img/tournaments/preview_labor_day_2025.png",
    Animal = "img/tournaments/preview_animal.png",
    Food = "img/tournaments/preview_food.png",
    Halloween = "img/tournaments/preview_halloween.png",
    Health = "img/tournaments/preview_health.png",
    Octoberfest = "img/tournaments/preview_octoberfest.png",
    Post = "img/tournaments/preview_post.png",
    Teacher = "img/tournaments/preview_teacher.png",
    United_Nations = "img/tournaments/preview_united_natons.png",
}